import { Construction } from 'lucide-react';
import { Card, EmptyState, PageHeader } from '@/components/ui';
import { t } from '@/lib/i18n';

const DESCRIPTIONS: Record<number, string> = {
  2: 'Leave types, policies, balances, apply-with-preview and the approval workflow.',
  3: 'Clock in/out, fingerprint-device import, daily attendance with late/early/missing detection.',
  4: 'Configurable reporting periods (default 25th → 24th) and month-end summaries.',
  7: 'Productivity dashboards fed by the Windows desktop agent.',
};

export function ComingSoonPage({ title, phase }: { title: string; phase: number }) {
  return (
    <div>
      <PageHeader title={t(title)} />
      <Card>
        <EmptyState
          icon={<Construction className="h-6 w-6" />}
          title={t('Built in Phase {phase}', { phase })}
          description={DESCRIPTIONS[phase] ? t(DESCRIPTIONS[phase]) : t('This section is part of a later phase.')}
        />
      </Card>
    </div>
  );
}

export function NotFoundPage() {
  return (
    <Card>
      <EmptyState title={t('Page not found')} description={t("The page you're looking for doesn't exist, or you don't have access to it.")} />
    </Card>
  );
}
